import { NgModule, Component } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DefaultLayoutComponent } from "../layout/default-layout/default-layout.component";
import { DashboardComponent } from "./dashboard.component";
import { PagesComponent } from "./pages/pages.component";
import { WorkDisplayComponent } from "./work-display-component/work-display.component";
import { DirectComponent } from "../direct/page/direct/direct.component";
import { PowerBiModuleEmbedComponent } from "../powerbi/powerbi-module-embed/powerbi-module-embed.component";
import { StaticDashboardEmbedComponent } from "../static-dashboard/static-dashboard-embed.component";
import { AiUsageEmbedComponent } from "../ai-usage/ai-usage-embed.component";
const routes: Routes = [
  // Alert Page
  {
    path: ":module/page/alert/config",
    pathMatch: "full",
    component: PagesComponent,
  },
  {
    path: ":module/page/alert/config/:bk_mrk_key",
    pathMatch: "full",
    component: PagesComponent,
  },
  {
    path: "",
    component: DashboardComponent,
  },
  {
    path: ":module",
    component: DashboardComponent,
  },

  // Default Pages
  {
    path: ":module/page",
    pathMatch: "full",
    component: PagesComponent,
  },
  {
    path: ":module/direct/:component",
    pathMatch: "full",
    component: DirectComponent,
  },
  {
    path: ":module/powerbi/:reportId",
    pathMatch: "full",
    component: PowerBiModuleEmbedComponent,
  },
  {
    path: ":module/static/:dashboardId",
    pathMatch: "full",
    component: StaticDashboardEmbedComponent,
  },
  {
    path: ":module/usage",
    pathMatch: "full",
    component: AiUsageEmbedComponent,
  },
  {
    path: ":module/page/:bk_mrk_key",
    pathMatch: "full",
    component: PagesComponent,
  },
  {
    path: ":module/:cardName",
    pathMatch: "full",
    component: PagesComponent,
  },
  {
    path: ":module/:cardName/:bk_mrk_key",
    pathMatch: "full",
    component: PagesComponent,
  },
  {
    path: ":module/:cardName/:FRM",
    pathMatch: "full",
    component: PagesComponent,
  },
  {
    path: ":module/:cardName/:FRM/:bk_mrk_key",
    pathMatch: "full",
    component: PagesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
